import styles from './FJMoreTool.module.less';
import FJAppConstant from '../../../../../constants/FJAppConstant.js';
import { RELEASE } from '../../../../../constants/FJEvnConstant.js';
import FJLocalStore from '../../../../../store/FJLocalStore.js';
import { AI_GENERATOR_VIDEO_TAB_TYPE } from '../../../../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJFlexClipIcon from '../../../../../assets/svg/community/FlexClip.svg?react';
import FJTextToImageIcon from '../../../../../assets/svg/community/text-to-image.svg?react';
import FJImageRemoveBgIcon from '../../../../../assets/svg/community/img-remove-bg.svg?react';
import FJPhotoEditorIcon from '../../../../../assets/svg/community/photo-editor.svg?react';
import FJSfxIcon from '../../../../../assets/svg/community/sfx.svg?react';
import FJImgToImgIcon from '../../../../../assets/svg/community/img-to-img.svg?react';
import FJImageToVideoIcon from '../../../../../assets/svg/community/img-to-video.svg?react';
import FJTextToVideoIcon from '../../../../../assets/svg/community/text-to-video.svg?react';
import FJObjectRemoveIcon from '../../../../../assets/svg/community/object-remove.svg?react';
import FJVideoRemoveBgIcon from '../../../../../assets/svg/community/video-remove-bg.svg?react';
import FJVideoEffectIcon from '../../../../../assets/svg/community/video-effect.svg?react';
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import FJUtil from '../../../../../util/FJUtil.js';
import FJCommunityUtil from '../../../../../util/FJCommunityUtil.js';

const environment = import.meta.env.MODE;
const isRelease = environment !== RELEASE;

const moreToolInfo = {};

moreToolInfo[FJAppConstant.TEXT_TO_IMAGE] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: 'editor/app',
        appType: FJAppConstant.FLEXCLIP_VIDEO_EDITOR,
    },
    {
        title: 'ai-image-to-video',
        icon: FJImageToVideoIcon,
        href: isRelease ? 'apply/video-generator/image-to-video' : 'ai/video-generator/image-to-video',
        appType: FJAppConstant.IMAGE_TO_VIDEO,
    },
    {
        title: 'ai-photo-editor',
        icon: FJPhotoEditorIcon,
        href: isRelease ? 'apply/photo-editor/' : 'ai/photo-editor/',
        appType: FJAppConstant.AI_PHOTO_EDITOR,
    },
    {
        title: 'ai-image-to-image',
        icon: FJImgToImgIcon,
        href: isRelease ? 'apply/image-to-image/' : 'ai/image-to-image/',
        appType: FJAppConstant.IMAGE_TO_IMAGE,
    },
    {
        title: 'ai-image-bg-remover',
        icon: FJImageRemoveBgIcon,
        href: isRelease ? 'apply/image-background-remover/' : 'ai/image-background-remover/',
        appType: FJAppConstant.PHOTO_REMOVE_BG,
    },
    {
        title: 'ai-object-eraser',
        icon: FJObjectRemoveIcon,
        href: isRelease ? 'apply/object-remover/' : 'ai/object-remover/',
        appType: FJAppConstant.OBJECT_ERASER,
    },
];

moreToolInfo[FJAppConstant.IMAGE_TO_IMAGE] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: 'editor/app',
        appType: FJAppConstant.FLEXCLIP_VIDEO_EDITOR,
    },
    {
        title: 'ai-image-to-video',
        icon: FJImageToVideoIcon,
        href: isRelease ? 'apply/video-generator/image-to-video' : 'ai/video-generator/image-to-video',
        appType: FJAppConstant.IMAGE_TO_VIDEO,
    },
    {
        title: 'ai-photo-editor',
        icon: FJPhotoEditorIcon,
        href: isRelease ? 'apply/photo-editor/' : 'ai/photo-editor/',
        appType: FJAppConstant.AI_PHOTO_EDITOR,
    },
    {
        title: 'ai-image-bg-remover',
        icon: FJImageRemoveBgIcon,
        href: isRelease ? 'apply/image-background-remover/' : 'ai/image-background-remover/',
        appType: FJAppConstant.PHOTO_REMOVE_BG,
    },
    {
        title: 'ai-object-eraser',
        icon: FJObjectRemoveIcon,
        href: isRelease ? 'apply/object-remover/' : 'ai/object-remover/',
        appType: FJAppConstant.OBJECT_ERASER,
    },
    {
        title: 'ai-text-to-image',
        icon: FJTextToImageIcon,
        href: isRelease ? 'apply/text-to-image/' : 'ai/text-to-image/',
        appType: FJAppConstant.TEXT_TO_IMAGE,
    },
];

moreToolInfo[FJAppConstant.AI_PHOTO_EDITOR] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: 'editor/app',
        appType: FJAppConstant.FLEXCLIP_VIDEO_EDITOR,
    },
    {
        title: 'ai-image-to-video',
        icon: FJImageToVideoIcon,
        href: isRelease ? 'apply/video-generator/image-to-video' : 'ai/video-generator/image-to-video',
        appType: FJAppConstant.IMAGE_TO_VIDEO,
    },
    {
        title: 'ai-image-to-image',
        icon: FJImgToImgIcon,
        href: isRelease ? 'apply/image-to-image/' : 'ai/image-to-image/',
        appType: FJAppConstant.IMAGE_TO_IMAGE,
    },
    {
        title: 'ai-image-bg-remover',
        icon: FJImageRemoveBgIcon,
        href: isRelease ? 'apply/image-background-remover/' : 'ai/image-background-remover/',
        appType: FJAppConstant.PHOTO_REMOVE_BG,
    },
    {
        title: 'ai-object-eraser',
        icon: FJObjectRemoveIcon,
        href: isRelease ? 'apply/object-remover/' : 'ai/object-remover/',
        appType: FJAppConstant.OBJECT_ERASER,
    },
    {
        title: 'ai-text-to-image',
        icon: FJTextToImageIcon,
        href: isRelease ? 'apply/text-to-image/' : 'ai/text-to-image/',
        appType: FJAppConstant.TEXT_TO_IMAGE,
    },
];

moreToolInfo[FJAppConstant.TEXT_TO_VIDEO] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: 'editor/app',
        appType: FJAppConstant.FLEXCLIP_VIDEO_EDITOR,
    },
    {
        title: 'ai-video-bg-remover',
        icon: FJVideoRemoveBgIcon,
        href: isRelease ? 'apply/video-background-remover/' : 'ai/video-background-remover/',
        appType: FJAppConstant.VIDEO_REMOVE_BG,
    },
    {
        title: 'ai-image-to-video',
        icon: FJImageToVideoIcon,
        href: isRelease ? 'apply/video-generator/image-to-video' : 'ai/video-generator/image-to-video',
        appType: FJAppConstant.IMAGE_TO_VIDEO,
    },
    {
        title: AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO,
        icon: FJVideoEffectIcon,
        href: isRelease ? 'apply/video-generator/video-effect/' : 'ai/video-generator/video-effect/',
        appType: FJAppConstant.AI_VIDEO_EFFECT,
    },
    {
        title: 'ai-photo-editor',
        icon: FJPhotoEditorIcon,
        href: isRelease ? 'apply/photo-editor/' : 'ai/photo-editor/',
        appType: FJAppConstant.AI_PHOTO_EDITOR,
    },
    {
        title: 'ai-video-dub',
        icon: FJSfxIcon,
        href: isRelease ? 'apply/video-to-ai-sfx-generator/' : 'ai/video-to-ai-sfx-generator/',
        appType: FJAppConstant.AI_VIDEO_DUB,
    },
];

moreToolInfo[FJAppConstant.IMAGE_TO_VIDEO] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: 'editor/app',
        appType: FJAppConstant.FLEXCLIP_VIDEO_EDITOR,
    },
    {
        title: 'ai-video-bg-remover',
        icon: FJVideoRemoveBgIcon,
        href: isRelease ? 'apply/video-background-remover/' : 'ai/video-background-remover/',
        appType: FJAppConstant.VIDEO_REMOVE_BG,
    },
    {
        title: 'ai-text-to-video',
        icon: FJTextToVideoIcon,
        href: isRelease ? 'apply/video-generator/text-to-video' : 'ai/video-generator/text-to-video',
        appType: FJAppConstant.TEXT_TO_VIDEO,
    },
    {
        title: AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO,
        icon: FJVideoEffectIcon,
        href: isRelease ? 'apply/video-generator/video-effect/' : 'ai/video-generator/video-effect/',
        appType: FJAppConstant.AI_VIDEO_EFFECT,
    },
    {
        title: 'ai-photo-editor',
        icon: FJPhotoEditorIcon,
        href: isRelease ? 'apply/photo-editor/' : 'ai/photo-editor/',
        appType: FJAppConstant.AI_PHOTO_EDITOR,
    },
    {
        title: 'ai-video-dub',
        icon: FJSfxIcon,
        href: isRelease ? 'apply/video-to-ai-sfx-generator/' : 'ai/video-to-ai-sfx-generator/',
        appType: FJAppConstant.AI_VIDEO_DUB,
    },
];

moreToolInfo[FJAppConstant.AI_VIDEO_EFFECT] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: 'editor/app',
        appType: FJAppConstant.FLEXCLIP_VIDEO_EDITOR,
    },
    {
        title: 'ai-video-bg-remover',
        icon: FJVideoRemoveBgIcon,
        href: isRelease ? 'apply/video-background-remover/' : 'ai/video-background-remover/',
        appType: FJAppConstant.VIDEO_REMOVE_BG,
    },
    {
        title: 'ai-text-to-video',
        icon: FJTextToVideoIcon,
        href: isRelease ? 'apply/video-generator/text-to-video' : 'ai/video-generator/text-to-video',
        appType: FJAppConstant.TEXT_TO_VIDEO,
    },
    {
        title: AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO,
        icon: FJVideoEffectIcon,
        href: isRelease ? 'apply/video-generator/video-effect/' : 'ai/video-generator/video-effect/',
        appType: FJAppConstant.AI_VIDEO_EFFECT,
    },
    {
        title: 'ai-photo-editor',
        icon: FJPhotoEditorIcon,
        href: isRelease ? 'apply/photo-editor/' : 'ai/photo-editor/',
        appType: FJAppConstant.AI_PHOTO_EDITOR,
    },
    {
        title: 'ai-video-dub',
        icon: FJSfxIcon,
        href: isRelease ? 'apply/video-to-ai-sfx-generator/' : 'ai/video-to-ai-sfx-generator/',
        appType: FJAppConstant.AI_VIDEO_DUB,
    },
];

const FJMoreTool = props => {
    const { jobType, generationType, workType, info } = props;
    const { list, currentAppType } = useMemo(() => {
        switch (jobType) {
            case 6:
                return {
                    list: moreToolInfo[FJAppConstant.TEXT_TO_IMAGE],
                    currentAppType: FJAppConstant.TEXT_TO_IMAGE,
                };
            case 3:
                return {
                    list: moreToolInfo[FJAppConstant.IMAGE_TO_IMAGE],
                    currentAppType: FJAppConstant.IMAGE_TO_IMAGE,
                };
            case 36:
                return {
                    list: moreToolInfo[FJAppConstant.AI_PHOTO_EDITOR],
                    currentAppType: FJAppConstant.AI_PHOTO_EDITOR,
                };
            case 28:
                return {
                    list: moreToolInfo[FJAppConstant.AI_VIDEO_EFFECT],
                    currentAppType: FJAppConstant.AI_VIDEO_EFFECT,
                };
            case 14:
                return {
                    list: moreToolInfo[
                        generationType === 'iv' ? FJAppConstant.IMAGE_TO_VIDEO : FJAppConstant.TEXT_TO_VIDEO
                    ],
                    currentAppType: generationType === 'iv' ? FJAppConstant.IMAGE_TO_VIDEO : FJAppConstant.TEXT_TO_VIDEO,
                };
            default:
                return { list: [], currentAppType: '' };
        }
    }, [jobType, generationType]);

    const _onClick = item => {
        // window.open(item.href, '_blank');
        const targetAppType = item.appType;
        const href = item.href;
        FJCommunityUtil.onPreviewJumpToApp(info, { currentAppType, targetAppType, href });
        FJUtil.eaLog('ai preview tools click', {
            tool: item.title.replaceAll('-', ' '),
            'current tools': FJUtil.getToolName(currentAppType),
            'ai page': FJCommunityUtil.getCommunityPageName({ workType }),
        });
    };

    return (
        <div className={styles.box}>
            <div className={styles.title}>{FJLocalStore._('more-tools')}</div>
            <div className={styles.tool_list}>
                {list.map((toolItem, index) => {
                    return (
                        <div
                            className={styles.item}
                            key={index}
                            onClick={() => {
                                _onClick(toolItem);
                            }}
                        >
                            <div className={styles.icon}>
                                <toolItem.icon />
                            </div>
                            <div className={styles.text}>{FJLocalStore._(toolItem.title)}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

FJMoreTool.propTypes = {
    jobType: PropTypes.number,
    generationType: PropTypes.string,
    workType: PropTypes.string,
    info: PropTypes.object,
};
export default FJMoreTool;
